import { useAxios } from "@hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";

/**
 * Removes an assessor assignment.
 */
export const useUnassignAssessor = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: async (assignmentId: string) => {
      await axios.delete(`/api/grading/assignments/${assignmentId}`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["pendingCorrections"] });
      queryClient.invalidateQueries({ queryKey: ["gradingAssignments"] });
    },
  });
};

export default useUnassignAssessor;
